"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fields_1 = require("../../fields/fields");
const botones_1 = require("../../botones");
const keautils_1 = require("keautils");
function filter(item, data, string) {
    return keautils_1.search(data.busqueda, string);
}
class FiltroBusquedaComponent extends React.PureComponent {
    render() {
        const props = this.props;
        const value = props.value || {};
        const busqueda = value.busqueda || "";
        const titulo = props.titulo;
        const label = React.createElement("span", null,
            React.createElement(botones_1.Link, { iconClass: "fa fa-times", onClick: props.onQuitar }),
            " ",
            React.createElement("label", null, titulo));
        return (React.createElement("div", null,
            React.createElement(fields_1.Text, { addon: React.createElement("i", { className: "fa fa-search" }), placeholder: "B\u00FAsqueda", label: label, value: busqueda, onChange: x => props.onChange({ busqueda: x }) })));
    }
}
exports.filtro = {
    component: FiltroBusquedaComponent,
    filter: (item, data, string) => filter(item, data, string)
};



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/filtros/busquedaTexto.js
// module id = 505
// module chunks = 0